/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';

/* External Imports */
import { Box, Link } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import WrapLayout from '@Layout/WrapLayout';
import Disclaimer from '@components/UI/Disclaimer';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import { getLandingPaths } from 'services/othersService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Page Data
 */
const RedirectToSite = ({ region, language, pageData }) => {
  const router = useRouter();
  const { url } = router.query;

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags}
        availableLocals={pageData?.availableLocales}
      ></HeadComponent>
      <Box
        h={{ base: '650px', sm: '600px' }}
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        m="15px"
        fontFamily="FedraSansStd-book"
      >
        <Disclaimer />
        <Box
          maxW="750px"
          bgColor="#f5f0e4"
          px={{ base: 5, sm: 10 }}
          py={{ base: 1, sm: 5 }}
          display="flex"
          justifyContent="center"
          flexDir="column"
          mt="0"
        >
          <Box as="p" py={4} fontSize="20px">
            You have clicked on a link which leaves our website, and you will be
            redirected to a third party website.
          </Box>
          <Box as="p" pb={2} fontSize="20px">
            We make no representations nor have any supervision or control over
            the quality, content, reliability or security of the third party
            website, nor shall we be liable for its use.
          </Box>

          {/* <Box
            as="button"
            my={5}
            mx="auto"
            bgColor="orange.50"
            textColor="white"
            px={5}
            py={2}
            borderRadius="5px"
            fontFamily="FedraSansStd-medium"
            w={200}
          > */}
          {router.query?.link && (
            <NextLink
              // href={
              //   `${(router.query?.url?.indexOf('https://') > -1 ||
              //     router.query?.url?.indexOf('http://') > -1)
              //     ? router.query?.url
              //     : decodeURI('http://' + router.query?.url)
              //   })`}
              passHref
              href={router.query?.link || '#'}
              legacyBehavior
            >
              <Link
                _hover={{
                  bg: '#000054',
                  textDecoration: 'none',
                }}
                mb="40px"
                display="block"
                fontWeight={500}
                fontFamily="FedraSansStd-medium"
                fontSize={'18px'}
                bgColor="#cf4520"
                h={'auto'}
                textAlign="center"
                padding="10px 36px"
                borderRadius="5px"
                color="#faf7f0"
                textDecoration="none"
                w={150}
                my={5}
                mx="auto"
                px={5}
                py={2}
              >
                Continue
              </Link>
            </NextLink>
          )}
        </Box>
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const redirectPaths = config.USE_LOCAL_URL
    ? [`/in/en/redirect-to-site`]
    : await getLandingPaths('lvl0', '/redirect-to-site');
  return {
    paths: redirectPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  // const pageData = await fetchDetails(region, language);

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      // pageData: pageData || null,
      isPreview: preview ? true : false,
    },
  };
};

export default RedirectToSite;
